module.exports = __webpack_public_path__ + "static/media/bad-full.c68a4af1.png";